import classNames from 'classnames';
//import ChatWidget from 'components/common/chat-widget/ChatWidget';
import Footer from 'components/footers/Footer';
//import NavbarDual from 'components/navbars/navbar-dual/NavbarDual';
//import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarVertical from 'components/navbars/navbar-vertical/NavbarVertical';
//import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  //const { config: { navbarPosition }  } = useAppContext();

  const { contentClass, footerClass } = useMainLayoutContext();

  return (
    <Container fluid className="px-0">

      <NavbarVertical />  {/* Sidebar laterale */}
      <NavbarTopDefault /> {/* Top Sidebar */}

      {/* 
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      {navbarPosition === 'vertical' && <NavbarTopDefault />}
      {(navbarPosition === 'horizontal' || navbarPosition === 'combo') && (
        <NavbarTopHorizontal />
      )}
      {navbarPosition === 'dual' && <NavbarDual />}
      */}

      <div className={classNames(contentClass, 'content')}>

        {/* Outlet is used to tell where we want to render child routes
          An <Outlet> should be used in parent route elements to render their child route elements. 
          This allows nested UI to show up when child routes are rendered. If the parent route matched exactly, 
          it will render a child index route or nothing if there is no index route.        
        */}
        <Outlet />

        <Footer className={classNames(footerClass, 'position-absolute')} />

        {/* <ChatWidget /> */}
      </div>
    </Container>
  );
};

export default MainLayout;
